import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en/translation.json";
import frTranslation from "./locales/fr/translation.json";
import ptTranslation from "./locales/pt/translation.json";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      fr: { translation: frTranslation },
      pt: { translation: ptTranslation },
    },
    fallbackLng: "fr",
    supportedLngs: ["en", "fr", "pt"],
    nonExplicitSupportedLngs: true,
    ns: ["translation"],
    defaultNS: "translation",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

/** Use i18n.translate("translationKey") for translations (works outside React components). */
export const i18n = {
  translate: (key: string, options?: Record<string, unknown>) =>
    i18next.t(key, options) as string,
};

export default i18next;
